import { FormProps, FormTypes } from "../../../shared/interfaces/form";

export const financialFormData = (id?: string, response?: any, lancamentos?: any, rubricas?: any, projects?: any, beneficiaries?: any, shouldShowProjectSelect = true): FormProps[] => {
    const data: FormProps[] = [
        {
            typeOfField: FormTypes.CURRENCY,
            type: 'number',
            placeholder: 'Valor*',
            value: id ? response?.valor / 100 : null,
            name: 'valor',
            rules: {
                required: 'Valor é obrigatório'
            },
            width: 740,
            height: 55,
            disabled: response?.project?.isFinished
        },
        {
            typeOfField: FormTypes.SELECT,
            type: 'text',
            placeholder: 'Lançamentos*',
            rules: {
                required: 'Lançamentos é obrigatório'
            },
            value: id ? response?.idTipoLancamento : null,
            name: 'idTipoLancamento',
            options: {
                placeholder: 'Lançamentos',
                data: lancamentos,
                value: id ? response?.idTipoLancamento : null
            },
            disabled: response?.project?.isFinished
        },
        {
            typeOfField: FormTypes.GROUPED_SELECT,
            type: 'text',
            placeholder: 'Rubrica*',
            rules: {
                required: 'Rubrica é obrigatória'
            },
            value: id ? response?.idRubrica : null,
            name: 'idRubrica',
            options: {
                placeholder: 'Rubrica',
                data: rubricas,
                value: id ? response?.idRubrica : null
            },
            disabled: response?.project?.isFinished      
        },
        {
            typeOfField: FormTypes.DATE,
            type: 'text',
            placeholder: 'Data do lançamento',
            rules: {
                required: 'Data do lançamento é obrigatória'
            },
            value: id ? response?.financialDateAdded : null,
            name: 'financialDateAdded',
            width: 500,
            height: 55,
            dateToday: true,
            disabled: response?.project?.isFinished
        },
        {
            typeOfField: FormTypes.SELECT,
            type: 'text',
            placeholder: 'Beneficiários',
            value: id ? response?.idBeneficiary : null,
            name: 'idBeneficiary',
            options: {
                placeholder: 'Beneficiários',
                data: beneficiaries,
                value: id ? response?.idBeneficiary : null
            },
            disabled: response?.project?.isFinished
        },
    ];

    if (shouldShowProjectSelect) {
        data.push({
            typeOfField: FormTypes.SELECT,
            type: 'text',
            placeholder: 'Projeto',
            value: id ? response?.idProject : null,
            name: 'idProject',
            rules: {
                required: 'Projeto é obrigatório'
            },
            options: {
                placeholder: 'Projeto',
                data: projects,
                value: id ? response?.idProject : null
            },
            disabled: response?.project?.isFinished
        });
    }
    
    data.push({
        typeOfField: FormTypes.TEXTAREA,
        type: 'text',
        placeholder: 'Descrição*',
        value: id ? response?.description : null,
        name: 'description',
        rules: {
            required: 'Descrição é obrigatória'
        },
        width: 740,
        height: 55,
        minRows: 4,
        maxRows: 10,
        disabled: response?.project?.isFinished
    });
    
    data.push({
        typeOfField: FormTypes.IMAGE,
        type: 'file',
        placeholder: 'Upload de documento',
        value: id ? response?.recipt : null,
        name: 'recipt',
        rules: { required: ""},
        width: 740,
        height: 55,
        disabled: response?.project?.isFinished
    });
    
    return data;
}  

export default financialFormData;